import React, { useState } from 'react'
import './map.css'
import { Link } from 'react-router-dom'
import m1 from './img/1.jpg'
import m2 from './img/2.jpg'
import m3 from './img/3.jpg'
import m4 from './img/4.jpg'

function Map() {

  const [fst, setfst] = useState(true)
  const [sec, setsec] = useState(false)
  const [trd, settrd] = useState(false)
  const [frt, setfrt] = useState(false)


  const fstclick =()=>{
    setfst(true)
    setsec(false)
    settrd(false)
    setfrt(false)
  }

  const secclick =()=>{
    setsec(true)
    setfst(false)
    settrd(false)
    setfrt(false)
  }
  const trdclick =()=>{
    settrd(true)
    setsec(false)
    setfst(false)
    setfrt(false)
  }
  const frtclick =()=>{
    setfrt(true)
    setsec(false)
    settrd(false)
    setfst(false)
  }

  return (
    <div className='main'>
      <Link to='/' style={{color:'white'}} >
        <p>Go Back</p>
      </Link> 
      <h3>RoadMap</h3>
      <div className='map'>
       
      <div className='bar'>
        <img src={m1} alt='' onClick={fstclick} />
        <img src={m2} alt='' onClick={secclick} />
        <img src={m3} alt=''  onClick={trdclick}/>
        <img src={m4} alt='' onClick={frtclick} />
      </div>

      <div className='sh'>
        
        {
          fst?
          <img src={m1} alt=''  />
          :
          null
        }

        {
          sec?
          <img src={m2} alt=''  />
          : null
        }
        
        {
          trd?
          <img src={m3} alt=''  />
          : null
        }
        
        {
          frt?
          <img src={m4} alt=''  />
          : null
        }
      </div>
      </div>
    </div>
  )
}

export default Map